module.exports = __webpack_public_path__ + "static/media/forbausa.19b5a241.m4a";